import React, { useState } from 'react'
import DeckGL, { FlyToInterpolator } from 'deck.gl'

import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { makeStyles } from '@material-ui/core/styles'
import LoopIcon from '@material-ui/icons/Loop'
import Alert from '@material-ui/lab/Alert'
import Collapse from '@material-ui/core/Collapse'

import Grow from '@material-ui/core/Grow'

import SearchBtn from '../../../../assets/map.png'

import './search.css'

const useStyles = makeStyles((theme) => ({
  txtContainer: {
    '& label.Mui-focused': {
      color: '#a65e44',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },
    width: '350px',
    height: '50px !important',
  },
  circle: {
    color: '#000000',
    opacity: '0.54',
    height: '24px !important',
    width: '24px !important',
    marginLeft: '13px',
    marginTop: '12px',
  },
}))

function Search(props) {
  const classes = useStyles()

  const [idPlants, setIdPlants] = useState(null)
  const [idSub, setIdSub] = useState(null)
  const [idMun, setIdMun] = useState(null)

  const [show, setShow] = useState({ plants: 'flex', sub: 'none', mun: 'none', lbl: 'Power Plants' })

  const [toggleSearch, setToggleSearch] = useState('plants')

  const [alerta, setAlerta] = useState(false)

  const handlePlants = (event, newValue) => {
    if (newValue != null) {
      setIdPlants(newValue.id)
    }
  }

  const handleSub = (event, newValue) => {
    if (newValue != null) {
      setIdSub(newValue.coordinates)
    }
  }

  const handleMun = (event, newValue) => {
    if (newValue != null) {
      setIdMun(newValue.id)
    }
  }

  const filtro = (name, type) => {
    if (name.trim() === '' && type === 'plants') document.getElementById('search-plant').focus()
    if (name.trim() === '' && type === 'sub') document.getElementById('search-sbn').focus()
    if (name.trim() === '' && type === 'mun') document.getElementById('search-mun').focus()

    if (name.trim() !== '' && type === 'plants') {
      if (props.plants.filter((dato) => dato.name_plant.toUpperCase().includes(name.toUpperCase())).length > 0) {
        setAlerta(false)
        const info = props.plants.filter((dato) => dato.id == idPlants)
        // console.log(info)
        props.viewState({
          longitude: info[0].coordinates[0],
          latitude: info[0].coordinates[1],
          zoom: 14,
          pitch: 0,
          bearing: 0,
          transitionDuration: 4000,
          transitionInterpolator: new FlyToInterpolator(),
        })
      }
      if (props.plants.filter((dato) => dato.name_plant.toUpperCase().includes(name.toUpperCase())).length <= 0) {
        setAlerta(true)
        setTimeout(() => setAlerta(false), 3000)
      }
    }

    if (name.trim() !== '' && type === 'sub') {
      if (props.substations.filter((dato) => dato.name_sbn.toUpperCase().includes(name.toUpperCase())).length > 0) {
        // const exist=dataSub.filter(dato => dato.name.toUpperCase().includes(name.toUpperCase()))
        setAlerta(false)
        props.viewState({
          longitude: idSub[0],
          latitude: idSub[1],
          zoom: 15,
          pitch: 0,
          bearing: 0,
          transitionDuration: 4000,
          transitionInterpolator: new FlyToInterpolator(),
        })
      }
      if (props.substations.filter((dato) => dato.name_sbn.toUpperCase().includes(name.toUpperCase())).length <= 0) {
        setAlerta(true)
        setTimeout(() => setAlerta(false), 3000)
      }
    }

    if (name.trim() !== '' && type === 'mun') {
      if (props.municipality.filter((dato) => dato.name.toUpperCase().includes(name.toUpperCase())).length > 0) {
        // const exist=dataPlants.filter(dato => dato.name.toUpperCase().includes(name.toUpperCase()))
        setAlerta(false)
        const info = props.municipality.filter((dato) => dato.id == idMun)
        props.viewState({
          longitude: info[0].coordinates[0],
          latitude: info[0].coordinates[1],
          zoom: 14,
          pitch: 0,
          bearing: 0,
          transitionDuration: 4000,
          transitionInterpolator: new FlyToInterpolator(),
        })
      }
      if (props.municipality.filter((dato) => dato.name.toUpperCase().includes(name.toUpperCase())).length <= 0) {
        setAlerta(true)
        setTimeout(() => setAlerta(false), 3000)
      }
    }
  }

  const toogle = () => {
    setAlerta(false)

    if (toggleSearch === 'plants') {
      setShow({ plants: 'flex', sub: 'none', mun: 'none', lbl: 'Power Plants' })
      setToggleSearch('sub')
      document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click()
    }
    if (toggleSearch === 'sub') {
      setShow({ plants: 'none', sub: 'flex', mun: 'none', lbl: 'Substations' })
      setToggleSearch('mun')
      document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1].click()
    }
    if (toggleSearch === 'mun') {
      setShow({ plants: 'none', sub: 'none', mun: 'flex', lbl: 'Municipality' })
      setToggleSearch('plants')
      document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2].click()
    }
  }

  return (
    <div>
      <Grow in={props.menu[2].view}>
        <div className="search-container">
          <div className="search-title-container">
            <label className="search-btn-select">{show.lbl}</label>
            <button className="search-toggle-btn" onClick={() => toogle()}>
              <LoopIcon className="loop-icon" />
            </button>
          </div>

          <div className="search-input" style={{ display: `${show.plants}` }}>
            <div className="search-lbl-container">
              <Autocomplete
                id="search-plant"
                freeSolo
                size="small"
                className={classes.txtContainer}
                options={props.plants}
                getOptionLabel={(option) => option.name_plant}
                renderOption={(option) => option.name_plant}
                getOptionSelected={(option) => option.id}
                onChange={handlePlants}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={classes.txtContainer}
                    id="outlined-basic"
                    label="Search plants"
                    variant="outlined"
                  />
                )}
              />
            </div>
            <button
              className="search-btn"
              onClick={() => filtro(document.getElementById('search-plant').value, 'plants')}
            >
              {' '}
              <img src={SearchBtn} className="icon-align-inf" />
            </button>
          </div>

          <div className="search-input" style={{ display: `${show.sub}` }}>
            <div className="search-lbl-container">
              <Autocomplete
                id="search-sbn"
                freeSolo
                size="small"
                className={classes.txtContainer}
                options={props.substations}
                getOptionLabel={(option) => option.name_sbn}
                renderOption={(option) => option.name_sbn}
                getOptionSelected={(option) => option.coordinates}
                onChange={handleSub}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={classes.txtContainer}
                    id="outlined-basic"
                    label="Search substations"
                    variant="outlined"
                  />
                )}
              />
            </div>
            <button className="search-btn" onClick={() => filtro(document.getElementById('search-sbn').value, 'sub')}>
              {' '}
              <img src={SearchBtn} className="icon-align-inf" />
            </button>
          </div>

          <div className="search-input" style={{ display: `${show.mun}` }}>
            <div className="search-lbl-container">
              <Autocomplete
                id="search-mun"
                freeSolo
                size="small"
                className={classes.txtContainer}
                options={props.municipality}
                getOptionLabel={(option) => option.name}
                renderOption={(option) => option.name}
                getOptionSelected={(option) => option.id}
                onChange={handleMun}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={classes.txtContainer}
                    id="outlined-basic"
                    label="Search municipality"
                    variant="outlined"
                  />
                )}
              />
            </div>
            <button className="search-btn" onClick={() => filtro(document.getElementById('search-mun').value, 'mun')}>
              {' '}
              <img src={SearchBtn} className="icon-align-inf" />
            </button>
          </div>

          <Collapse in={alerta}>
            <Alert severity="error" style={{ zIndex: '10' }}>
              Facility not found
            </Alert>
          </Collapse>
        </div>
      </Grow>
    </div>
  )
}

export default Search
